
import ProductSliderListItem from '@/components/ProductSliderListItem.vue'

export default {
  name: 'ConfiguratorHeadlightType',
  components: { ProductSliderListItem },
  props: {
    headlight_type: Object,
    vehicle: Object,
    isDefaultOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      products: [],
      filled: false,
      loadingProducts: true,
      headlight_vehicle_details_list: [],
      selectedDetail: null,
    }
  },

  computed: {
    cartMetadata() {
      const meta = {
        headlight_type_id: this.headlight_type.id,
        vehicle_id: this.vehicle.id,
      }
      if (this.selectedDetail && this.selectedDetail !== -1) {
        meta.headlight_vehicle_detail_id = this.selectedDetail
      }
      return meta
    },
    collapseFromUrl() {
      // Open if URL specifies this type OR if this is the default and no collapse is specified
      if (this.$route.query.collapseIndex == this.headlight_type.id) {
        return true
      }
      return this.isDefaultOpen && !this.$route.query.collapseIndex
    },
    headlightDetailOptions() {
      const options = [
        {
          value: null,
          text:
            this.$t('components.configuratorHeadlightType.selectOption') ||
            'Sélectionner une option',
          disabled: true,
        },
      ]
      return options.concat(
        this.headlight_vehicle_details_list.map(detail => ({
          value: detail.id,
          text: detail.name,
        }))
      )
    },
  },

  mounted() {
    // Load products if collapse is open by default (b-collapse @shown doesn't fire on initial visible)
    if (this.collapseFromUrl) {
      this.$nextTick(() => {
        this.fillProducts()
      })
    }
  },

  methods: {
    selectDetail(detailId) {
      if (this.headlight_vehicle_details_list.length > 1) {
        this.selectedDetail = detailId
        this.filled = false
        this.fillProducts()
      }
    },
    handleDetailChange(value) {
      if (value && this.headlight_vehicle_details_list.length > 1) {
        const selectedDetailItem = this.headlight_vehicle_details_list.find(
          d => d.id === value
        )
        this.$trackVehicleEvent(this.vehicle.id, 'select_technology', {
          headlight_type_id: this.headlight_type.id,
          metadata: { detail_name: selectedDetailItem?.name },
        })
        this.filled = false
        this.fillProducts()
      }
    },

    async getProducts() {
      this.loadingProducts = true
      await this.$productService
        .fetchConfiguratorVehicleHeadlightTypeProducts(
          this.vehicle.id,
          this.headlight_type.id,
          {
            limit: 14,
            headlight_vehicle_detail_id: this.selectedDetail,
          }
        )
        .then(({ data }) => {
          this.products = data
        })

      await this.$productService
        .fetchConfiguratorVehicleHeadlightTypeProducts(
          this.vehicle.id,
          this.headlight_type.id,
          {
            limit: 14 - this.products.length,
            headlight_vehicle_detail_id: this.selectedDetail,
            exclude_ids: this.products.map(p => p.id).join(','),
            fill: 1,
          }
        )
        .then(({ data }) => {
          this.products = this.products.concat(data)
        })
        .finally(() => {
          this.filled = true
          this.loadingProducts = false
        })
    },

    trackProductClick(event) {
      const card = event.target.closest('.card-product')
      if (!card) return
      const link = card.querySelector('a[href*="/produit/"]')
      if (!link) return
      const productSlug = link
        .getAttribute('href')
        ?.split('/produit/')[1]
        ?.split('?')[0]
      const product = this.products.find(p => p.slug === productSlug)
      this.$trackVehicleEvent(this.vehicle.id, 'product_click_from_vehicle', {
        headlight_type_id: this.headlight_type.id,
        product_id: product?.id,
        metadata: {
          product_name: product?.name,
          headlight_type_name: this.headlight_type.name,
        },
      })
    },

    async fillProducts() {
      this.$trackVehicleEvent(this.vehicle.id, 'select_lighting_type', {
        headlight_type_id: this.headlight_type.id,
        metadata: { headlight_type_name: this.headlight_type.name },
      })
      if (!this.filled) {
        if (this.headlight_vehicle_details_list.length == 0) {
          await this.$productService
            .fetchConfiguratorVehicleHeadlightDetails(
              this.vehicle.id,
              this.headlight_type.id
            )
            .then(({ data }) => {
              this.headlight_vehicle_details_list = data

              if (this.headlight_vehicle_details_list.length > 1) {
                this.loadingProducts = false
              } else if (this.headlight_vehicle_details_list.length == 1) {
                this.selectedDetail = this.headlight_vehicle_details_list[0].id
              } else {
                this.loadingProducts = false
                this.filled = true
              }
            })
        }

        this.selectedDetail =
          this.headlight_vehicle_details_list.length == 1
            ? this.headlight_vehicle_details_list[0].id
            : this.selectedDetail

        if (
          this.selectedDetail ||
          this.headlight_vehicle_details_list.length == 1
        ) {
          await this.getProducts()
        }
      }
    },
  },
}
